import { takeLatest, put } from "redux-saga/effects";
import { APIReq } from "../api";
import {
  SEND_MAIL_REQUEST,
  sendMailFailure,
  sendMailSuccess,
} from "../redux/Calc_reducer";
import {
  sendChatFailure,
  SEND_CHAT_REQUEST,
  sendChatSuccess,
} from "../redux/Chat_reducer";
import { showPage } from "../redux/Main_reducer";

function* rootSaga() {
  yield takeLatest(SEND_MAIL_REQUEST, mail_Saga);
  yield takeLatest(SEND_CHAT_REQUEST, chat_Saga);
}

function* mail_Saga({ payload }) {
  try {
    const formData = new FormData();
    const basket = [];
    const booleanHandle = (v) =>
      typeof v === "boolean" ? (v ? "Да" : "Нет") : v;
    for (const item of payload.basket) {
      const {
        view,
        sum,
        depth,
        format,
        number,
        material,
        formatMM1,
        formatMM2,
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        processing,
        processingValue,
        ...rest
      } = item;
      const position = {
        Количество: number,
        Вид: view,
        Сумма: sum,
        Толщина: depth + "мм",
        Форма: format,
        Материал: material,
        Обработка: processingValue,
      };
      for (const [key, value] of Object.entries(rest)) {
        if (key.includes("_Значение")) position[key.slice(0, -9)] = value;
        else if (!position[key]) position[key] = booleanHandle(value);
      }
      if (formatMM2) {
        position["Высота"] = formatMM1 + "мм";
        position["Ширина"] = formatMM2 + "мм";
      } else {
        position["Диаметр"] = formatMM1 + "мм";
      }
      basket.push(position);
    }
    formData.append(
      "data",
      JSON.stringify({
        ...payload,
        allSum: payload.allSum + " руб.",
        basket,
      }),
    );
    if (payload?.file?.name) {
      formData.append("files.file", payload.file, payload.file.name);
    }
    const response = yield APIReq.mail(formData);
    if (response.status >= 200 && response.status < 400) {
      const txt = `Уважаемый ${payload.fio}, Ваша заявка успешно создана, в течении дня Вам позвонит сотрудник`;
      yield put(showPage(txt));
      yield put(sendMailSuccess(txt));
    }
  } catch (e) {
    yield put(
      sendMailFailure(
        "Не удалось отправить заказ, попробуйте ещё раз или позвоните по телефону +7(977)530-49-25",
      ),
    );
  }
}

function* chat_Saga({ payload }) {
  try {
    const response = yield APIReq.chat(payload);
    if (response.status >= 200 && response.status < 400) {
      const txt =
        "Уважаемый клиент, Ваша заявка успешно создана, в течении дня Вам позвонит сотрудник";
      yield put(showPage(txt));
      yield put(sendChatSuccess(txt));
    }
  } catch (e) {
    yield put(
      sendChatFailure(
        "Не удалось отправить вопрос, попробуйте ещё раз или позвоните по телефону +7(977)530-49-25",
      ),
    );
  }
}

export default rootSaga;
